import {Injectable, signal, Signal} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FeedbackDialogService {
    showFeedbackWidget = signal(false);

    openFeedback() {
        this.showFeedbackWidget.set(true);
    }

    closeFeedback() {
        this.showFeedbackWidget.set(false);
    }

    get showFeedbackWidgetSignal(): boolean {
        return this.showFeedbackWidget();
    }

    set showFeedbackWidgetSignal(value: boolean) {
        this.showFeedbackWidget.set(value);
    }
}
